import AlertPanel from 'ext-ui/components/AlertPanel/AlertPanel'
import AlertShieldIcon from 'ext-ui/svg/icon/AlertShieldIcon'
import React, { ReactElement } from 'react'
import { Link } from 'react-router-dom'
import style from 'src/feature/CVSVerificationHomepageAlert/CVSVerificationHomepageAlert.style'
import { useTranslate } from 'src/localization/Trns'

type CVSVerificationHomepageAlertProps = {
  className?: string
  linkTo: string
}

function CVSVerificationHomepageAlert(
  props: CVSVerificationHomepageAlertProps,
): ReactElement {
  const { className = '', linkTo } = props
  const translate = useTranslate()

  return (
    <AlertPanel variant="severe-wcag" className={className}>
      <div className="CVSVerificationHomepageAlert" css={style}>
        <div className="icon-column">
          <AlertShieldIcon />
        </div>
        <div className="content-column">
          <p className="title">
            {translate('Verification required for your added security')}
          </p>
          <p>
            {translate('Please complete your ')}
            <Link
              className="link"
              to={linkTo}
              aria-label={translate('card enrollment')}
            >
              {translate('card enrollment')}
            </Link>
            {translate(' to enable physical card transactions')}
          </p>
        </div>
      </div>
    </AlertPanel>
  )
}

export default CVSVerificationHomepageAlert
